import { Body, Controller, Post } from "@nestjs/common";
import { ApplicationService } from "./application.service";
import { ApiTags } from "@nestjs/swagger";
import { ApplicationExceptionHandler } from "@schemax-whatsapp/backend-utils";
import { ApplicationResponse } from "./model/application-response.model";
import { ApplicationModel } from "./model/application.model";

@ApiTags('Application')
@Controller('application')
export class ApplicationController{
 constructor(
    private applicationService:ApplicationService,
    private applicationExceptionHandler: ApplicationExceptionHandler

 ){}

 @Post('/addApplications')
  create(@Body() createapplication: ApplicationModel) {
    try{
    return this.applicationService.addApplications(createapplication);
  }catch(error){
    return this.applicationExceptionHandler.returnException(ApplicationResponse,error);

  }
}
@Post('/getallApplications')
findAll(){
    return this.applicationService.getallApplications();
}
}